<template>
  <vs-popup
    class="holamundo exhibitor-option-popup-wrap"
    title="Exhibitors - Advanced Settings"
    :active.sync="popupActive2"
  >
    <ul class="option-inner-wrap mb-5">
      <li>
        <label for>Allow Business Card Exchange</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/business-card-exchange.jpg"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.AllowBusinessCardExchange" />
        </div>
      </li>
      <br />
      <li>
        <label for>View Enhanced (hotspotting)</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/view-enhanced.jpg"
                alt="View Enhanced (hotspotting)
"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.IsEnhancedHotspotting" />
        </div>
      </li>
      <br />
      <li>
        <label for>Allow Attendee To create Meeting With Exhibitor Contacts</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img src="../../assets/images/create-meeting.jpg" alt="Display" />
            </div>
          </div>
          <vs-switch
            v-model="settingsData.AllowAttendeeMeetingWithExhibitors"
          />
        </div>
      </li>
      <li>
        <label for>Allow Attendee To chat With Exhibitor Contacts</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img src="../../assets/images/chat_settings.png" alt="Display" />
            </div>
          </div>
          <vs-switch
            v-model="settingsData.AllowAttendeeChatWithExhibitors"
            @click="
              turnPluginForChatOn(settingsData.AllowAttendeeChatWithExhibitors)
            "
          />
        </div>
      </li>
      <br />
      <li>
        <label for>Display Exhibitor contact list on Booths</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img src="../../assets/images/rep-active.jpg" alt="Display" />
            </div>
          </div>
          <vs-switch v-model="settingsData.DisplayExhibitorContactsOnBooths" />
        </div>
      </li>
      <br />
      <li>
        <label for>Display Round tables for Expo Booths</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/display-round-table.jpg"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.DisplayRoundtablesforExpoBooths" />
        </div>
      </li>
      <br />
      <li>
        <label for>Enable Chat/Email with Exhibitor</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img src="../../assets/images/create-meeting.jpg" alt="Display" />
            </div>
          </div>
          <vs-switch v-model="settingsData.EnableChatOrEmailwithExhibitor" />
        </div>
      </li>
      <br />
      <!-- <li>
              <label for>Enable Enhanced Expo Mode</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips">
                    <img src="../../assets/images/Enable-enhanced-expo-mode.jpg" alt="Display"/>
                  </div>
                </div>
                <vs-switch v-model="settingsData.EnableEnhancedExpoMode" />
              </div>
            </li> -->
      <br />
      <li>
        <label for>Enable Exhibitor Search Option</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img src="../../assets/images/search-option.jpg" alt="Display" />
            </div>
          </div>
          <vs-switch
            v-model="settingsData.EnableExhibitorFilterAndSearchOption"
          />
        </div>
      </li>
      <li>
        <label for>Enable Exhibitor Filter Option</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img src="../../assets/images/search-option.jpg" alt="Display" />
            </div>
          </div>
          <vs-switch v-model="settingsData.EnableExhibitorFilter" />
        </div>
      </li>
      <br />
      <li>
        <label for>Enable Exhibitor Showcase Video</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img src="../../assets/images/showcase-video.jpg" alt="Display" />
            </div>
          </div>
          <vs-switch v-model="settingsData.EnableExhibitorShowcaseVideo" />
        </div>
      </li>
      <br />
      <li>
        <label for>Show Exhibitor Collaterals for download</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/collaterals-download.jpg"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch
            v-model="settingsData.ShowExhibitorCollateralsForDownload"
          />
        </div>
      </li>
      <br />
      <li>
        <label for>Allow More Than one to join Rep In VideoCall</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img src="../../assets/images/more-one-join.jpg" alt="Display" />
            </div>
          </div>
          <vs-switch
            v-model="settingsData.AllowMoreThan1tojoinRepInVideoCall"
          />
        </div>
      </li>
      <br />
      <li>
        <label for>Show Rep Active Status</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img src="../../assets/images/rep-active.jpg" alt="Display" />
            </div>
          </div>
          <vs-switch v-model="settingsData.ShowRepActiveStatus" />
        </div>
      </li>
      <!-- <li>
               <label for>Allow Aerial View for Booths</label>
                <div class="popup-single-upload-right">
                  <div class="info-option-wrapper">
                    <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                    <div class="popup-info-tooltips">
                      <img src="../../assets/images/aerial_booths.png" alt="Display"/>
                    </div>
                  </div>
                  <vs-switch v-model="settingsData.AllowAerialView" />
                </div>
            </li> -->
      <li>
        <label for>Show Mouse Cursor</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/mouse_cursor_exhibitor.png"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.IsMouseCursorEnabled" />
        </div>
      </li>
      <li>
        <label for>Show Exhibitor Tooltips</label>
        <div class="popup-single-upload-right">
          <vs-switch v-model="settingsData.IsExpoAlertEnabled" />
        </div>
      </li>
      <li>
        <label for>Allow Appointment In ExpoDetails</label>
        <div class="popup-single-upload-right">
          <vs-switch v-model="settingsData.AllowAppointmentInExpoDetails" />
        </div>
      </li>
      <li>
        <label for>Allow Request Meeting In ExpoHall  </label>
        <div class="popup-single-upload-right">
          <vs-switch v-model="settingsData.AllowRequestMeetingInExpoHall" />
        </div>
      </li>
      <li>
        <label for>Allow Group Chat InExpo Details</label>
        <div class="popup-single-upload-right">
          <vs-switch v-model="settingsData.AllowGroupChatInExpoDetails" />
        </div>
      </li>
      <br />
      <li>
        <label for>Enable Exhibitor Rep Video Call</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips info-top-custom-tooltip">
              <img src="../../assets/images/create-meeting.jpg" alt="Display" />
            </div>
          </div>
          <vs-switch v-model="settingsData.EnableExhibitorRepVideoCall" />
        </div>
      </li>
      <li>
        <label for>Auto Play Booth Video</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips info-top-custom-tooltip">
              <img
                src="../../assets/images/autoplayboothvideo.png"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.EnableExhibitorAutoPlayBoothVideo" />
        </div>
      </li>
      <li>
        <label for>Lock Exhibitor Booth Setup</label>
        <div class="popup-single-upload-right">
          <vs-switch v-model="settingsData.LockExhibitorBoothSetup" />
        </div>
      </li>
      <li>
        <label for>Show Request Meeting In Expo Hall</label>
        <div class="popup-single-upload-right">
          <vs-switch v-model="settingsData.ShowRequestMeetingInExpoHall" />
        </div>
      </li>
      <li class="session-option-upload-area">
        <div class="popup-single-upload">
          <label for>Expo Hall Background Image (2000px x 1125px)</label>
          <span class="option-right-area">
            <img
              v-show="ExpoHallBackgroundImageSrc"
              :src="ExpoHallBackgroundImageSrc"
              class="mr-8 rounded h-10 w-10"
            />
            <vs-button
              color="primary"
              type="filled"
              @click="$refs.update_avatar.click()"
              class="upload-btn"
              >Upload</vs-button
            >
            <input
              ref="update_avatar"
              type="file"
              accept="image/*"
              @change="
                update_avatar(
                  $event,
                  '2000x1125',
                  'ExpoHallBackgroundImageFile',
                  'ExpoHallBackgroundImageSrc'
                )
              "
            />
          </span>
        </div>
      </li>
      <li>
        <div class="file-up-section">
          <label for>Order By</label>
          <div class="popup-single-upload-right">
            <vs-radio
              v-model="orderByExhibitor"
              vs-value="BoothNo"
              class="mr-4"
              vs-name="layout-type-vertical1"
              >Booth No</vs-radio
            >
            <vs-radio
              v-model="orderByExhibitor"
              vs-value="Name"
              class="mr-4"
              vs-name="layout-type-vertical1"
              >Name</vs-radio
            >
          </div>
        </div>
      </li>
    </ul>
    <div class="file-up-section">
      <div class="booth-radios">
        <label>Select Expo Hall View</label>
        <div class="ml-3 booth-toggles">
          <vs-radio
            v-model="expoBoothRadios"
            vs-value="default"
            class="mr-4"
            vs-name="layout-type-vertical"
            >Default</vs-radio
          >
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips info-top-custom-tooltip">
              <img
                src="../../assets/images/Enable-enhanced-expo-mode.jpg"
                alt="Display"
              />
            </div>
          </div>
        </div>
        <div class="booth-toggles">
          <vs-radio
            v-model="expoBoothRadios"
            vs-value="aerial"
            class="mr-4"
            vs-name="layout-type-vertical"
            >Aerial View</vs-radio
          >
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips info-top-custom-tooltip">
              <img src="../../assets/images/aerial_booths.png" alt="Display" />
            </div>
          </div>
        </div>
        <div class="booth-toggles">
          <vs-radio
            v-model="expoBoothRadios"
            vs-value="bird"
            class="mr-4"
            vs-name="layout-type-vertical"
            >Bird's Eye View</vs-radio
          >
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips info-top-custom-tooltip">
              <img src="../../assets/images/bird_view.png" alt="Display" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="conversation-text-wrap mb-5">
      <p class="mt-2">
        <span>Join The Conversation Text</span>
        <a href="javascript:void(0)" @click="resetSettings">Reset</a>
      </p>
      <quill-editor v-model="settingsData.JoinTheConversationText" />
    </div>
    <!-- <vs-button class="sub-btn mr-5" @click="resetSettings">Reset</vs-button> -->
    <vs-button color="rgb(76, 139, 246)" type="filled"class="sub-btn" v-on:click="saveSettings"
      >Save</vs-button
    >
  </vs-popup>
</template>
<script>
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import { quillEditor } from "vue-quill-editor";
var vm;
export default {
  components: {
    quillEditor,
  },
  props: {
    data: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      settingsData: { IsEnhancedHotspotting: false },
      IsDefaultSettings: false,
      popupActive2: this.data,
      ExpoHallBackgroundImageSrc: null,
      orderByExhibitor: "BoothNo",
      expoBoothRadios: "default",
      data_local: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    turnPluginForChatOn(data) {
      if (!data == true) {
        debugger;
        this.data_local.OneToOneChat = !data;
        this.data_local.defaultChatMsg = "Hi 👋";
        this.$store
          .dispatch("eventManagement/addUpdatePlugin", {
            data: this.data_local,
          })
          .then((res) => {
            if (res.status == 200) {
              console.log("Plugins Updated");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getDefaultSettings() {
      this.IsDefaultSettings = true;
      this.ExpoHallBackgroundImageFile = null;
      this.ExpoHallBackgroundImageSrc = null;
      this.expoBoothRadios = "default";
      this.orderByExhibitor = "BoothNo";
      this.settingsData = {
        AllowAerialView: false,
        AllowAttendeeMeetingWithExhibitors: true,
        AllowBusinessCardExchange: true,
        AllowMoreThan1tojoinRepInVideoCall: true,
        AllowbirdView: false,
        DisplayExhibitorContactsOnBooths: true,
        DisplayRoundtablesforExpoBooths: true,
        EnableChatOrEmailwithExhibitor: true,
        EnableEnhancedExpoMode: true,
        EnableExhibitorFilterAndSearchOption: true,
        EnableExhibitorRepVideoCall: true,
        EnableExhibitorShowcaseVideo: true,
        ExpoHallBackgroundImage: null,
        IsEnhancedHotspotting: true,
        JoinTheConversationText:
          "<p>Welcome to {BoothName} Our Reps are here to assist you. You can also contact us on {phone} or visit {BoothWebsite}</p>",
        OrderBy: "BoothNo",
        ShowExhibitorCollateralsForDownload: true,
        ShowRepActiveStatus: true,
        EnableExhibitorAutoPlayBoothVideo: true,
        AllowAppointmentInExpoDetails: false,
        AllowRequestMeetingInExpoHall: false,
        LockExhibitorBoothSetup: false,
        AllowGroupChatInExpoDetails: false,
        ShowRequestMeetingInExpoHall: false
      };
      this.popupActive2 = true;
    },
    getSettings() {
      this.$vs.loading();
      this.IsDefaultSettings = false;
      this.$store.dispatch("exhibitorManagement/getSettings").then((res) => {
        this.settingsData = res;
        this.settingsData.JoinTheConversationText = res.JoinTheConversationText
          ? res.JoinTheConversationText
          : this.JoinTheConversationTexDefault;
        this.ExpoHallBackgroundImageFile = null;
        this.ExpoHallBackgroundImageSrc = res.ExpoHallBackgroundImage
          ? res.ExpoHallBackgroundImage
          : null;

        if (this.settingsData.EnableEnhancedExpoMode == true) {
          this.expoBoothRadios = "default";
        } else if (this.settingsData.AllowAerialView == true) {
          this.expoBoothRadios = "aerial";
        } else if (this.settingsData.AllowbirdView == true) {
          this.expoBoothRadios = "bird";
        }
        this.orderByExhibitor =
          this.settingsData.OrderBy == undefined
            ? "BoothNo"
            : this.settingsData.OrderBy;
        this.settingsData.AllowAppointmentInExpoDetails = res.AllowAppointmentInExpoDetails ? res.AllowAppointmentInExpoDetails : false
        this.settingsData.AllowRequestMeetingInExpoHall= res.AllowRequestMeetingInExpoHall ? res.AllowRequestMeetingInExpoHall : false
        this.settingsData.LockExhibitorBoothSetup= res.LockExhibitorBoothSetup ? res.LockExhibitorBoothSetup : false
        this.settingsData.AllowGroupChatInExpoDetails= res.AllowGroupChatInExpoDetails ? res.AllowGroupChatInExpoDetails : false
        this.settingsData.ShowRequestMeetingInExpoHall = res.ShowRequestMeetingInExpoHall ? res.ShowRequestMeetingInExpoHall  : false

        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    resetSettings() {
      this.settingsData.JoinTheConversationText = this.JoinTheConversationTexDefault;
    },

    saveSettings() {
      this.$vs.loading();
      if (this.expoBoothRadios == "default") {
        this.settingsData.EnableEnhancedExpoMode = true;
        this.settingsData.AllowAerialView = false;
        this.settingsData.AllowbirdView = false;
      } else if (this.expoBoothRadios == "aerial") {
        this.settingsData.EnableEnhancedExpoMode = false;
        this.settingsData.AllowAerialView = true;
        this.settingsData.AllowbirdView = false;
      } else {
        this.settingsData.EnableEnhancedExpoMode = false;
        this.settingsData.AllowAerialView = false;
        this.settingsData.AllowbirdView = true;
      }
      this.settingsData.OrderBy = this.orderByExhibitor;
      this.$store
        .dispatch("exhibitorManagement/saveSettings", {
          settingsData: this.settingsData,
          ExpoHallBackgroundImageFile: this.ExpoHallBackgroundImageFile,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$emit("saveExhibitorSettingsData");
          this.$vs.loading.close();
        });
    },
    gcd(a, b) {
      return b == 0 ? a : vm.gcd(b, a % b);
    },
    update_avatar(input, fileDimension, fieldName, srcName) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileDimension.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if (this.width == dimension[0] && this.height == dimension[1]) {
            let r = vm.gcd(this.width, this.height);
            if (this.width / r == 16 && this.height / r == 9) {
              vm[fieldName] = file;
              const reader = new FileReader();
              reader.onload = (e) => {
                vm[srcName] = e.target.result;
              };
              reader.readAsDataURL(input.target.files[0]);
            } else {
              alert("File ratio does not match: 16:9");
            }
          } else {
            alert("File dimension does not match " + fileDimension);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
  },
  mounted() {},
  created() {
    vm = this;
    if (!moduleExhibitorManagement.isRegistered) {
      this.$store.registerModule(
        "exhibitorManagement",
        moduleExhibitorManagement
      );
      moduleExhibitorManagement.isRegistered = true;
    }
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.$store.dispatch("exhibitorManagement/getSettings").then((res) => {
      this.settingsData = res;
      this.ExpoHallBackgroundImageSrc = res.ExpoHallBackgroundImage
        ? res.ExpoHallBackgroundImage
        : null;
      if (this.settingsData.AllowAttendeeMeetingWithExhibitors == null) {
        this.getDefaultSettings();
      }
    });
  },
};
</script>
<style scoped>
.option-inner-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.option-inner-wrap li {
  list-style: none;
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 10px;
}


.popup-info-tooltips {
  position: absolute;
  right: 0;
  z-index: 99999;
  background: #fff;
  padding: 10px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 421px;
  height: 297px;
  overflow: hidden;
  top: 100%;
}
.popup-info-tooltips.info-top-custom-tooltip {
  top: -300px !important;
  right: 0;
}
</style>